/**
 * @class Modal
 *
 * @method constructor
 *     @param {HTMLElement} el
 *
 * @method toggleModal
 * @method init
 *
 * Create a modal
 */

const selectors = {
    close: '.js-modal-close',
    form: '.js-form',
    expandable: '.js-expandable',
};

const classes = {
    open: 'is-open',
    visible: 'is-visible',
    locked: 'is-locked',
};

export default class Modal {
    constructor(el) {
        this.el = el;
        this.close = el.querySelector(selectors.close);
        this.triggers = document.querySelectorAll(
            `[data-modal-trigger="${this.el.id}"]`,
        );
        this.form = this.el.querySelector(selectors.form);
        this.expandables = el.querySelectorAll(selectors.expandable);

        this.isOpen = false;

        this.init();
    }

    toggleModal(isOpen) {
        if (isOpen && !this.isOpen) {
            this.openModal();
        } else if (!isOpen && this.isOpen) {
            this.closeModal();
        }

        this.isOpen = isOpen;
    }

    openModal() {
        this.el.classList.add(classes.open);
        this.el.setAttribute('aria-hidden', false);
        document.body.classList.add(classes.locked);
        this.isOpen = true;

        if (this.form) {
            const formData = new FormData(this.form);
            this.form.dataset.formData = JSON.stringify(
                Object.fromEntries(formData),
            );
        }

        this.expandables.forEach(expandable => {
            if (!expandable.expandable) return;
            expandable.expandable.setHeight();
        });

        requestAnimationFrame(() => {
            this.el.classList.add(classes.visible);
        });
    }

    closeModal() {
        this.el.classList.remove(classes.visible);
        this.isOpen = false;

        setTimeout(() => {
            this.el.classList.remove(classes.open);
            this.el.setAttribute('aria-hidden', true);

            if (!this.el.parentElement.closest('.js-modal'))
                document.body.classList.remove(classes.locked);

            this.expandables.forEach(expandable => {
                if (!expandable.expandable) return;
                expandable.expandable.toggleContent(false);
            });
        }, 500);
    }

    init() {
        this.close.addEventListener('click', () => {
            if (this.form) {
                const formResetPrev = new CustomEvent('formResetPrev', {
                    bubbles: true,
                });
                this.form.dispatchEvent(formResetPrev);
            }

            this.closeModal();
        });

        window.addEventListener('keyup', e => {
            if (e.key === 'Escape') this.closeModal();
        });

        this.triggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                this.openModal();
            });
        });

        window.addEventListener('click', e => {
            let isOutsideTrigger = true;
            this.triggers.forEach(trigger => {
                if (trigger.contains(e.target)) isOutsideTrigger = false;
            });
            const isOutsideModal =
                e.target !== this.el && !this.el.contains(e.target);
            if (isOutsideTrigger && isOutsideModal && this.isOpen) {
                e.preventDefault();
                this.closeModal();
            }
        });
    }
}
